import AfterConfirmationActions from './AfterConfirmationActions.component';

export default AfterConfirmationActions;
